import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";
import { CardAula } from "../AulaCard/styles";

// ---- Trilha completa ----
export const ContainerTrilha = styled.div<{ theme: ThemeType }>`
  padding: 5rem 4rem 12rem;
  color: ${({ theme }) => theme.colors.tertiary};

  /* banner na proporção 1098 x 152 (não amplia além do tamanho real -> sem embaçar) */
  .banner-trilha {
    text-align: center;
    .capa {
      display: block;
      width: 100%;
      max-width: 1098px;
      aspect-ratio: 1098 / 152;
      height: auto;
      object-fit: cover;
      border-radius: 4rem;
      margin: 0 auto;
    }
  }

  .trilha-intro {
    text-align: center;
    max-width: 90rem;
    margin: 4rem auto 0;
    padding: 0 4rem;
    strong {
      display: block;
      color: ${({ theme }) => theme.colors.secondary};
      margin-bottom: 1rem;
    }
  }

  /* barra de progresso da trilha (estilo YouTube, cores do Conecta) */
  .trilha-progresso {
    max-width: 90rem;
    margin: 3rem auto 0;
    padding: 0 4rem;
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1rem;
      .pct {
        font-weight: 700;
      }
    }
    .barra {
      height: 6px;
      border-radius: 3px;
      background-color: ${({ theme }) => theme.colors.elements};
      overflow: hidden;
      .preenchido {
        height: 100%;
        border-radius: 3px;
        background-color: ${({ theme }) => theme.colors.secondary};
        transition: width 0.4s ease;
      }
    }
  }

  /* o zig-zag rola sozinho (classe global .scrollBonito); banner + título fixos acima */
  .timeline {
    max-width: 110rem;
    margin: 4rem auto 0;
    padding: 0 4rem 2rem;
    max-height: calc(100vh - 440px);
    overflow-x: hidden;
    /* esconde o scroll; aparece suave (fade) com o mouse em cima */
    scrollbar-color: transparent transparent;
    transition: scrollbar-color 0.3s ease;
    &::-webkit-scrollbar-thumb {
      background-color: transparent;
      transition: background-color 0.3s ease;
    }
    &:hover {
      scrollbar-color: ${({ theme }) => theme.colors.elements} transparent;
      &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.colors.elements};
      }
    }
  }
  .timeline-inner {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      border-left: 2px dashed ${({ theme }) => theme.colors.elements};
    }
    .timeline-item {
      position: relative;
      display: flex;
      margin-bottom: 5rem;
      width: 50%;
      &.left {
        justify-content: flex-end;
        padding-right: 5rem;
      }
      &.right {
        margin-left: 50%;
        justify-content: flex-start;
        padding-left: 5rem;
      }
      .ponto {
        position: absolute;
        top: 9rem;
        width: 2.2rem;
        height: 2.2rem;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.secondary};
        display: flex;
        align-items: center;
        justify-content: center;
        .check {
          width: 1.7rem;
          height: 1.7rem;
          color: #fff;
        }
      }
      &.left .ponto {
        right: -1.1rem;
      }
      &.right .ponto {
        left: -1.1rem;
      }
      ${CardAula} {
        width: 100%;
        max-width: 32rem;
        height: 19rem;
      }
    }
  }

  /* telas pequenas: mantém o zig-zag, mas cards/padding menores pra caber */
  @media (max-width: 600px) {
    .timeline {
      padding: 0 2rem 2rem;
    }
    .timeline-inner .timeline-item {
      &.left {
        padding-right: 3rem;
      }
      &.right {
        padding-left: 3rem;
      }
      ${CardAula} {
        max-width: 26rem;
        height: 16rem;
      }
    }
  }

  /* só abaixo de 425px vira coluna única (zig-zag fica apertado demais) */
  @media (max-width: 425px) {
    .banner-trilha .capa {
      aspect-ratio: 1098 / 382;
    }
    .timeline-inner {
      &::before {
        left: 1rem;
      }
      .timeline-item {
        width: 100%;
        margin-left: 0;
        justify-content: flex-start;
        padding-left: 4rem;
        padding-right: 0;
        &.left,
        &.right {
          justify-content: flex-start;
          margin-left: 0;
          padding-left: 4rem;
        }
        .ponto,
        &.left .ponto,
        &.right .ponto {
          left: -0.1rem;
          right: auto;
        }
        ${CardAula} {
          max-width: 100%;
          height: 36rem;
        }
      }
    }
  }
`;
